(function () {
  'use strict';

  var SECTION_ID = 'cart-drawer';
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;

  var panel = root.querySelector('[data-cart-drawer-panel]');
  var overlay = root.querySelector('[data-cart-drawer-overlay]');
  var lastFocus = null;

  // Reusable safety visibility check
  function checkHintSafety() {
    var totalEl = root.querySelector('[data-cart-total]');
    var hintEl = root.querySelector('.cart-drawer__checkout-hint');
    if (!hintEl) return;

    var totalCents = totalEl ? parseInt(totalEl.getAttribute('data-cart-total'), 10) || 0 : 0;
    var minOrderCents = 19000; // $190.00 threshold in cents

    if (totalCents >= minOrderCents || totalCents === 0) {
      hintEl.style.display = 'none';
    } else {
      hintEl.style.display = 'block';
    }
  }

  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    if (typeof window.lockScroll === 'function') window.lockScroll();
    var closeBtn = panel.querySelector('[data-cart-drawer-close]');
    if (closeBtn) closeBtn.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    closeRecs();
    root.setAttribute('aria-hidden', 'true');
    if (typeof window.unlockScroll === 'function') window.unlockScroll();
    document.removeEventListener('keydown', onKeydown);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  // Mobile only: expand / collapse the recs peek panel
  function toggleRecs(btn) {
    if (window.matchMedia('(min-width: 768px)').matches) return;
    var isOpen = root.classList.toggle('cart-drawer--recs-open');
    if (btn) btn.setAttribute('aria-expanded', String(isOpen));
  }
  function closeRecs() {
    root.classList.remove('cart-drawer--recs-open');
    var head = root.querySelector('[data-cart-drawer-recs-toggle]');
    if (head) head.setAttribute('aria-expanded', 'false');
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      if (root.classList.contains('cart-drawer--recs-open')) closeRecs();
      else close();
      return;
    }
    if (e.key === 'Tab') trapFocus(e);
  }

  function trapFocus(e) {
    var recsOpen = root.classList.contains('cart-drawer--recs-open');
    var container = (recsOpen && root.querySelector('[data-cart-drawer-recs]')) || panel;
    var f = Array.prototype.filter.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])',
      ),
      function (el) { return el.offsetParent !== null; },
    );
    // Recs peek toggle sits outside the panel: add it as the last stop
    if (!recsOpen) {
      var toggle = root.querySelector('[data-cart-drawer-recs-toggle]');
      if (toggle && toggle.offsetParent !== null) f.push(toggle);
    }
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-open]')) {
      e.preventDefault();
      open();
      return;
    }
    if (e.target.closest('[data-cart-drawer-close]') || e.target === overlay) {
      e.preventDefault();
      close();
      return;
    }
    var recsToggle = e.target.closest('[data-cart-drawer-recs-toggle]');
    if (recsToggle) {
      e.preventDefault();
      toggleRecs(recsToggle);
      return;
    }
    var checkout = e.target.closest('[data-cart-drawer-checkout]');
    if (checkout && checkout.classList.contains('is-disabled')) {
      e.preventDefault();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    if (e.target.closest && e.target.closest('[data-cart-drawer-open]')) {
      e.preventDefault();
      open();
    }
  });

  root.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-drawer-notice-toggle]');
    if (!toggle) return;
    var wrap = toggle.closest('[data-cart-drawer-notice]');
    var body = wrap.querySelector('[data-cart-drawer-notice-body]');
    var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(willOpen));
    wrap.classList.toggle('is-open', willOpen);
    if (body) body.hidden = !willOpen;
  });

  function syncHeaderCount(incomingRoot) {
    var src = incomingRoot.querySelector('[data-cart-drawer-count]');
    if (!src) return;
    var count = src.getAttribute('data-count') || '0';
    var headerCount =
      document.querySelector('#site-control .cart [data-cart-icon-count]') ||
      document.querySelector('#site-control .cart > div');
    if (headerCount) headerCount.textContent = count;
  }

  function maybeReseedRecs(incomingRoot) {
    var recEl = root.querySelector('[data-cart-drawer-recs]');
    if (!recEl) return;
    var newSeed = incomingRoot.getAttribute('data-cart-drawer-seed') || '';
    var curSeed = root.getAttribute('data-cart-drawer-seed') || '';
    if (newSeed && newSeed !== curSeed) {
      root.setAttribute('data-cart-drawer-seed', newSeed);
      if (recEl.dataset.url)
        recEl.dataset.url = recEl.dataset.url.replace(/product_id=\d+/, 'product_id=' + newSeed);
      recEl.dataset.productId = newSeed;
      recEl.dataset.recommendationsPerformed = 'false';
    }
  }

  function applySection(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var incoming = tmp.querySelector('[data-cart-drawer]');
    if (!incoming) return;

    // Update standard components
    [
      '[data-cart-drawer-count]',
      '[data-cart-drawer-items]',
      '[data-cart-drawer-progress]',
      '[data-cart-drawer-checkout]',
    ].forEach(function (sel) {
      var cur = root.querySelector(sel);
      var next = incoming.querySelector(sel);
      if (cur && next) cur.replaceWith(next);
    });

    // Handle structural checkout hint injection safely
    var curHint = root.querySelector('.cart-drawer__checkout-hint');
    var nextHint = incoming.querySelector('.cart-drawer__checkout-hint');
    var footer = root.querySelector('[data-cart-drawer-footer]');

    if (nextHint) {
      if (curHint) {
        curHint.replaceWith(nextHint);
      } else if (footer) {
        footer.appendChild(nextHint);
      }
    } else if (curHint) {
      curHint.remove();
    }

    // sync footer visibility
    var curFooter = root.querySelector('[data-cart-drawer-footer]');
    var nextFooter = incoming.querySelector('[data-cart-drawer-footer]');
    if (curFooter && nextFooter) curFooter.hidden = nextFooter.hidden;

    // Add recs when the cart gains its first item, remove when it empties
    var curRecs = root.querySelector('[data-cart-drawer-recs]');
    var nextRecs = incoming.querySelector('[data-cart-drawer-recs]');
    if (nextRecs && !curRecs) {
      // Load product-recommendations.js if the page rendered with an empty cart
      var wrap = root.querySelector('.cart-drawer__wrap');
      if (wrap) wrap.insertBefore(nextRecs, wrap.firstChild);
      var recScript = incoming.querySelector('script[src*="product-recommendations"]');
      if (recScript) {
        var recScriptSrc = recScript.getAttribute('src');
        if (recScriptSrc && !document.querySelector('script[src="' + recScriptSrc + '"]')) {
          var s = document.createElement('script');
          s.type = 'module';
          s.src = recScriptSrc;
          document.head.appendChild(s);
        }
      }
      root.classList.add('cart-drawer--has-recs');
    } else if (!nextRecs && curRecs) {
      curRecs.remove();
      root.classList.remove('cart-drawer--has-recs');
    }

    // Run safety conditional check
    checkHintSafety();

    syncHeaderCount(incoming);
    maybeReseedRecs(incoming);
    var live = root.querySelector('[data-cart-drawer-live]');
    if (live) live.textContent = 'Panier mis à jour';
  }

  function render(html) {
    if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.startViewTransition(function () {
        applySection(html);
      });
    } else {
      applySection(html);
    }
  }

  function changeLine(line, quantity) {
    root.classList.add('cart-drawer--loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: SECTION_ID,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.sections && data.sections[SECTION_ID]) render(data.sections[SECTION_ID]);
      })
      .catch(function (err) {
        console.error('[cart-drawer] change failed', err);
      })
      .finally(function () {
        root.classList.remove('cart-drawer--loading');
      });
  }

  root.addEventListener('click', function (e) {
    var ctrl = e.target.closest(
      '[data-cart-drawer-minus], [data-cart-drawer-plus], [data-cart-drawer-remove]',
    );
    if (!ctrl) return;
    e.preventDefault();
    var li = ctrl.closest('[data-line]');
    if (!li) return;
    var line = parseInt(li.getAttribute('data-line'), 10);
    var qty = parseInt(li.getAttribute('data-quantity'), 10);
    if (ctrl.hasAttribute('data-cart-drawer-minus')) qty = Math.max(0, qty - 1);
    else if (ctrl.hasAttribute('data-cart-drawer-plus')) qty = qty + 1;
    else qty = 0;
    changeLine(line, qty);
  });

  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn) {
      btn.classList.add('is-loading');
      btn.setAttribute('disabled', 'disabled');
    }
    open();
    root.classList.add('cart-drawer--loading');
    var body = new FormData(form);
    body.append('sections', SECTION_ID);
    body.append('sections_url', window.location.pathname);
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) {
        return r.json().then(function (d) {
          return { ok: r.ok, data: d };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          throw new Error(res.data && res.data.description ? res.data.description : 'Add failed');
        }
        if (res.data.sections && res.data.sections[SECTION_ID])
          render(res.data.sections[SECTION_ID]);
      })
      .catch(function (err) {
        console.error('[cart-drawer] add failed', err);
      })
      .finally(function () {
        root.classList.remove('cart-drawer--loading');
        if (btn) {
          btn.classList.remove('is-loading');
          btn.removeAttribute('disabled');
        }
      });
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action$="/cart/add"]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addToCart(form);
    },
    true,
  );

  // Initial structural validation pass
  checkHintSafety();

  // Recs toggle is only focusable on mobile (always open on desktop)
  var mobileBreakpoint = window.matchMedia('(max-width: 767px)');
  function syncRecsToggleTabindex() {
    var toggle = root.querySelector('[data-cart-drawer-recs-toggle]');
    if (!toggle) return;
    toggle.tabIndex = mobileBreakpoint.matches ? 0 : -1;
  }
  syncRecsToggleTabindex();
  mobileBreakpoint.addEventListener('change', syncRecsToggleTabindex);

  // :has() fallback
  if (root.querySelector('[data-cart-drawer-recs]')) root.classList.add('cart-drawer--has-recs');

  window.CartDrawer = { open: open, close: close, root: root };
})();
